module.exports = __webpack_public_path__ + "static/media/other-viola.185df8c3.mp3";